import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-chat-count',
  templateUrl: './chat-count.component.html',
  styleUrls: ['./chat-count.component.scss'],
})
export class ChatCountComponent implements OnChanges {
  @Input() type = '';
  @Input() count: any = null;
  likeArr: string[] = [];
  @Input() userId = '';
  @Output() replies = new EventEmitter();
  @Output() likeUnlike = new EventEmitter();
  constructor() {}

  ngOnChanges(): void {
    if (typeof this.count == 'string') {
      this.likeArr = this.count ? this.count.split(',') : [];
    }
  }
}
